import { Stack } from '@cast/design-system';

import { useAutoOptimization } from '../../_hooks/useAutoOptimization';
import { WizardScreenLayout } from '../wizard/WizardScreenLayout';
import { BinPackingSection } from './_components/BinPackingSection';
import { NodeAutoscalerSection } from './_components/NodeAutoscalerSection';
import { WorkloadAutoscalerSection } from './_components/WorkloadAutoscalerSection';

export const RecommendationsScreen = () => {
  const {
    state: { features },
  } = useAutoOptimization();

  return (
    <WizardScreenLayout
      nextButtonLabel="Apply"
      title="Ready to optimize?"
      description="Review your setup and apply. You can change any of this from the feature pages later."
    >
      <Stack gap={16}>
        {features.nodeAutoscaling && <NodeAutoscalerSection />}
        {features.workloadAutoscaling && <WorkloadAutoscalerSection />}
        <BinPackingSection />
      </Stack>
    </WizardScreenLayout>
  );
};
